/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Enhanced_HolsterInputs */

const cs_property_ai_enhanced_holster = /** @type {(inputs: Property_Ai_Enhanced_HolsterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepublikované AI fotky`)
};

const en_property_ai_enhanced_holster = /** @type {(inputs: Property_Ai_Enhanced_HolsterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpublished AI photos`)
};

/**
* | output |
* | --- |
* | "Unpublished AI photos" |
*
* @param {Property_Ai_Enhanced_HolsterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_enhanced_holster = /** @type {((inputs?: Property_Ai_Enhanced_HolsterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Enhanced_HolsterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_enhanced_holster(inputs)
	return cs_property_ai_enhanced_holster(inputs)
});